import { render, staticRenderFns } from "./CreateGroupHeadDialog.vue?vue&type=template&id=5c0f85b3&scoped=true&lang=true"
import script from "./CreateGroupHeadDialog.vue?vue&type=script&lang=js"
export * from "./CreateGroupHeadDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupHeadDialog.vue?vue&type=style&index=0&id=5c0f85b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f85b3",
  null
  
)

export default component.exports